import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e9f93fe")

_pushScopeId("data-v-6e9f93fe")
const _hoisted_1 = { class: "responsive-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_claim_detail_card = _resolveComponent("claim-detail-card")!
  const _component_claim_rejected_reason_card = _resolveComponent("claim-rejected-reason-card")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Title, {
      label: _ctx.$t('dashboard.claim')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_claim_detail_card, {
        class: 
          `${
            _ctx.checkActiveSectionDashboard('rejected_reason') ? 'responsive-detail-width' : 'w-full'
          }`
        
      }, null, 8, ["class"]),
      (_ctx.checkActiveSectionDashboard('rejected_reason'))
        ? (_openBlock(), _createBlock(_component_claim_rejected_reason_card, {
            key: 0,
            class: "responsive-reason-width"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
})